import { Component, Input } from '@angular/core';
import { ElementDefinitionSingleSelectionModel, ElementModel, ElementSingleSelectionModel, Form, FormElement, FormElementError, FormElementState, TranslationManager, ViewState } from 'src/common';
import { ElementMode, ElementOrderDirection, ElementViewModel } from '../elements.model';

@Component({
  selector: 'element-singleselection',
  templateUrl: './element-singleselection.component.html'
})
export class ElementSingleSelectionComponent {

  @Input() mode: ElementMode = ElementMode.Definition;
  elementMode = ElementMode;
  @Input() state: ViewState;
  @Input() showOrderUp: boolean;
  @Input() showOrderDown: boolean;
  viewState = ViewState;
  form: Form = new Form();
  formValue: Form = new Form();
  translationManager = TranslationManager;
  private _element: ElementViewModel;
  elementOrderDirection = ElementOrderDirection;

  @Input() set element(value: ElementViewModel) {
    this._element = value;
    this._element.isValid = this.isValid.bind(this);
    this._element.isValueValid = this.isValueValid.bind(this);
    this._element.getElement = this.getElement.bind(this);
    this._element.getValue = this.getValue.bind(this);
    this.mapElementToForm();
    this.refreshFormState();
  }

  constructor() {
    this.initForm();
  }

  isValid(): boolean {
    return this.form.isValid();
  }

  isValueValid(): boolean {
    return this.formValue.isValid();
  }

  getValue(): any {
    return this.formValue.elements['value'].value;
  }

  getElement(): ElementModel {
    this.mapFormToElement();
    return this._element.element;
  }

  private initForm() {
    this.form.elements['name'] = new FormElement();
    this.form.elements['isMandatory'] = new FormElement();
    this.form.elements['definition'] = new FormElement();
    this.form.elements['definition'].onValidation = ElementSingleSelectionComponent.selectionValueValidator;
    this.formValue.elements['value'] = new FormElement();
    this.formValue.elements['valueName'] = new FormElement();
  }

  private mapElementToForm() {
    let model: ElementSingleSelectionModel = this._element.element.data as ElementSingleSelectionModel;

    this.form.elements['name'].value = model.name;
    this.form.elements['isMandatory'].value = model.isMandatory;
    this.form.elements['definition'].value = model.definition;
    this.formValue.elements['value'].value = this._element.element.value;
    if (this._element.element.value) {
      let selectedDefinition = model.definition.find(s => s.id == this._element.element.value);

      if (selectedDefinition) {
        this.formValue.elements['valueName'].value = selectedDefinition.value
      }
    }
  }

  private refreshFormState() {
    this.form.elements['name'].state.mandatory = this.mode == ElementMode.Definition;
    this.form.elements['definition'].state.mandatory = this.mode == ElementMode.Definition;
    this.formValue.elements['value'].state.mandatory = this.form.elements['isMandatory'].value;
  }

  private mapFormToElement() {
    let model: ElementSingleSelectionModel = this._element.element.data as ElementSingleSelectionModel;

    model.name = this.form.elements['name'].value;
    model.isMandatory = this.form.elements['isMandatory'].value;
    model.definition = this.form.elements['definition'].value;
  }

  addSelectionValue() {

    if (!this.form.elements['definition'].value) {
      this.form.elements['definition'].value = [];
    }

    this.form.elements['definition'].value.push(new ElementDefinitionSingleSelectionModel());
  }

  deleteSelectionValue(item: ElementDefinitionSingleSelectionModel) {
    this.form.elements['definition'].value.splice(this.form.elements['definition'].value.indexOf(item), 1);
  }

  delete() {
    this._element.delete(this._element);
  }

  static selectionValueValidator(value: any, state: FormElementState, error: FormElementError) {
    if (state) {
      if (state.mandatory) {
        if (value && value.length > 0) {
          error.required = false;
          value.forEach(element => {
            if (!error.required && (!element.value || element.value.trim() == '')) {
              error.required = true;
            }
          });
        }
      }
    }
  }
}
